import { inject, Injectable, OnDestroy } from "@angular/core"
import { StateStorageFactory } from "./state-storage.factory"
import { StateStorageOptions, StateStore } from "./state-storage.model"
import { merge } from "lodash-es"

@Injectable()
export abstract class BaseState<T, E = T> implements OnDestroy {
  protected abstract config: StateStorageOptions<T>
  protected reduceMethod: 'replace' | 'merge' | 'mergeDeep' = 'replace'

  private factory = inject(StateStorageFactory)
  private storageInstance?: StateStore<T>

  protected get storage(): StateStore<T> {
    if (!this.storageInstance) {
      this.storageInstance = this.factory.create<T>(this.config)
    }
    return this.storageInstance
  }

  get state$() {
    return this.storage.state$
  }

  getState() {
    return this.storage.getState()
  }

  handleEvent(event: E) {
    const nextState = this.reduce(this.storage.getState(), event)
    this.storage.setState(nextState)
  }

  ngOnDestroy() {
    this.storageInstance?.dispose()
  }

  protected reduce(_state: T, event: E): T {
    if (this.reduceMethod === 'replace') {
      return event as unknown as T
    }
    if (this.reduceMethod === 'merge') {
      return { ..._state, ...event }
    }
    return merge({}, _state, event) as unknown as T
  }
}
